import * as z from 'zod';

// Live-view visibility options enum
export const liveViewOption = z.enum(['always_on', 'always_off', 'default_on', 'default_off']);
export type LiveViewOption = z.infer<typeof liveViewOption>;

// Auto-booking mode (which Shigoto strategy picks the timeframe for a sensor event)
export const autoBookingMode = z.enum(['exact', 'categorical']);
export type AutoBookingMode = z.infer<typeof autoBookingMode>;

// Model for DesklyConnect settings
export const desklyConnectSettings = z.object({
    active: z.boolean(),
    autoBooking: z.boolean(),
    autoBookingMode: autoBookingMode,
    hotDeskingDisabledForAnyLocation: z.boolean(),
    liveViewVisibility: liveViewOption,
});

export type DesklyConnectSettings = z.infer<typeof desklyConnectSettings>;

// Form model for updating DesklyConnect settings
export const desklyConnectForm = z.object({
    active: z.boolean(),
    autoBooking: z.boolean(),
    autoBookingMode: autoBookingMode,
    liveViewVisibility: liveViewOption,
});

export type DesklyConnectForm = z.infer<typeof desklyConnectForm>;
